import React from "react";
import { Link } from "react-router-dom";
import EyeIcon from "@public/img/eye.svg";
import { WatchedMovieData } from "@/entry/server/movie";
import { ASSETS_BASE_URL } from "@/utils/constants";
import TrashIcon from "@public/img/trash.svg";

type WatchProgressTone = "red" | "yellow" | "green";

export function getWatchProgressTone(
  watchedTime: number,
  duration: number
): WatchProgressTone {
  if (duration <= 0) {
    return "red";
  }
  var percent = (watchedTime / duration) * 100;
  if (percent < 25) {
    return "red";
  }
  if (percent <= 75) {
    return "yellow";
  }
  return "green";
}

function formatWatchedTimeParts(seconds: number): { minutes: string; secs: string } {
  var safe = Math.max(0, Math.floor(seconds));
  return {
    minutes: String(Math.floor(safe / 60)),
    secs: String(safe % 60),
  };
}

function buildPlayerHref(item: WatchedMovieData, isSeries: boolean): string {
  if (!isSeries) {
    return "/player/" + item.id;
  }
  return (
    "/player/" +
    item.id +
    "?season=" +
    String(item.season_number ? item.season_number : 1) +
    "&episode=" +
    String(item.episode_number ? item.episode_number : 1)
  );
}

type WatchedMovieCardProps = {
  item: WatchedMovieData;
  isSeries: boolean;
  onRemove: () => void;
};

export default function WatchedMovieCard({ item, isSeries, onRemove }: WatchedMovieCardProps) {
  var tone = getWatchProgressTone(item.watched_time, item.duration);
  var progressPercent = 0;
  if (item.duration > 0) {
    progressPercent = Math.min(100, Math.max(0, (item.watched_time / item.duration) * 100));
  }
  var timeParts = formatWatchedTimeParts(item.watched_time);
  var posterSrc =
    item.thumbnail.indexOf("http") === 0 ? item.thumbnail : ASSETS_BASE_URL + item.thumbnail;

  var iconClass = "watch-list-card__icon watch-list-card__icon--" + tone;
  var barClass = "watch-list-card__progress-fill watch-list-card__progress-fill--" + tone;

  return (
    <Link to={buildPlayerHref(item, isSeries)} className="watch-list-card">
      <div className="watch-list-card__poster">
        <img src={posterSrc} alt={item.title} className="watch-list-card__image" />
        <button
          type="button"
          className="watch-list-card__remove"
          onClick={function (e) {
            e.stopPropagation();
            e.preventDefault();
            onRemove();
          }}
        >
          <img src={TrashIcon} alt="حذف" />
        </button>
        <div className="watch-list-card__overlay">
          <div className="watch-list-card__meta">
            <div className="watch-list-card__time-row">
              <div className={iconClass}>
                <img src={EyeIcon} alt="" />
              </div>
              <div className="watch-list-card__time">
                <p className="watch-list-card__time-line">
                  <span className="watch-list-card__time-minutes">{timeParts.minutes}</span>
                  <span> دقیقه</span>
                </p>
                <p className="watch-list-card__time-line">
                  <span className="watch-list-card__time-secs">{timeParts.secs}</span>
                  <span> ثانیه</span>
                </p>
              </div>
            </div>
            <div className="watch-list-card__progress">
              <div className={barClass} style={{ width: progressPercent + "%" }}></div>
            </div>
          </div>
        </div>
      </div>
      <p className="watch-list-card__title">{item.title}</p>
    </Link>
  );
}
